function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2002 2C6.6802 2 2.2002 6.48 2.2002 12C2.2002 17.52 6.6802 22 12.2002 22C17.7202 22 22.2002 17.52 22.2002 12C22.2002 6.48 17.7202 2 12.2002 2ZM12.2002 20C7.7902 20 4.2002 16.41 4.2002 12C4.2002 7.59 7.7902 4 12.2002 4C16.6102 4 20.2002 7.59 20.2002 12C20.2002 16.41 16.6102 20 12.2002 20ZM16.0802 8.29L10.2002 14.17L8.3202 12.29C7.9302 11.9 7.3002 11.9 6.9102 12.29C6.5202 12.68 6.5202 13.31 6.9102 13.7L9.5002 16.29C9.8902 16.68 10.5202 16.68 10.9102 16.29L17.5002 9.7C17.8902 9.31 17.8902 8.68 17.5002 8.29C17.1102 7.9 16.4702 7.9 16.0802 8.29Z",
  fill: "currentColor"
});

function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.f25cd89f.svg";
export { ForwardRef as ReactComponent };